import { useNotificationWorkflow } from "./notificationSettings/useNotificationWorkflow";
import { FixedToast, NotificationTabBar } from "./notificationSettings/shared";
import { WebhookRegistryTab } from "./notificationSettings/WebhookRegistryTab";
import { NotificationSubscriptionsTab } from "./notificationSettings/NotificationSubscriptionsTab";
import { LexAiServicesTab } from "./notificationSettings/LexAiServicesTab";
import { EventLogsTab } from "./notificationSettings/EventLogsTab";

export default function NotificationSettings() {
  const wf = useNotificationWorkflow();

  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-[#FCFCFC]">
      <FixedToast toast={wf.toast} />

      <div className="flex-1 overflow-auto">
        <NotificationTabBar activeTab={wf.tab} onTabChange={wf.setTab} />

        <div className="px-8 py-7 max-w-[1200px]">
          {wf.tab === "webhooks" && (
            <WebhookRegistryTab
              webhooks={wf.webhooks}
              integrations={wf.whIntegrations}
              whName={wf.whName}
              setWhName={wf.setWhName}
              whUrl={wf.whUrl}
              setWhUrl={wf.setWhUrl}
              whAuthType={wf.whAuthType}
              setWhAuthType={wf.setWhAuthType}
              whOAuthConfig={wf.whOAuthConfig}
              setWhOAuthConfig={wf.setWhOAuthConfig}
              whFieldErrors={wf.whFieldErrors}
              whResponse={wf.whResponse}
              loadWebhooks={wf.loadWebhooks}
              onCreateWebhook={wf.onCreateWebhook}
              onPatchWebhook={wf.onPatchWebhook}
              onToggleWebhook={wf.onToggleWebhook}
              onDeleteWebhook={wf.onDeleteWebhook}
              editingWebhook={wf.editingWebhook}
              setEditingWebhook={wf.setEditingWebhook}
              whPatchSaving={wf.whPatchSaving}
              isWebhookAdmin={wf.isWebhookAdmin}
            />
          )}

          {wf.tab === "notifications" && (
            <NotificationSubscriptionsTab
              lexaiEvents={wf.lexaiEvents}
              nsEventId={wf.nsEventId}
              setNsEventId={wf.setNsEventId}
              nsWebhookId={wf.nsWebhookId}
              setNsWebhookId={wf.setNsWebhookId}
              nsDestKind={wf.nsDestKind}
              setNsDestKind={wf.setNsDestKind}
              nsEndpointId={wf.nsEndpointId}
              setNsEndpointId={wf.setNsEndpointId}
              endpointCatalog={wf.endpointCatalog}
              nsPayloadTemplate={wf.nsPayloadTemplate}
              setNsPayloadTemplate={wf.setNsPayloadTemplate}
              nsDedupKeyTemplate={wf.nsDedupKeyTemplate}
              setNsDedupKeyTemplate={wf.setNsDedupKeyTemplate}
              nsDedupWindow={wf.nsDedupWindow}
              setNsDedupWindow={wf.setNsDedupWindow}
              nsResponse={wf.nsResponse}
              nsTestResponse={wf.nsTestResponse}
              notificationRows={wf.notificationRows}
              activeWebhooks={wf.activeWebhooks}
              loadNotificationSettingsList={wf.loadNotificationSettingsList}
              onCreateNS={wf.onCreateNS}
              onToggleNS={wf.onToggleNS}
              onDeleteNS={wf.onDeleteNS}
              onTestNS={wf.onTestNS}
            />
          )}

          {wf.tab === "lexai" && (
            <LexAiServicesTab
              lexaiApiId={wf.lexaiApiId}
              setLexaiApiId={wf.setLexaiApiId}
              lexaiResponse={wf.lexaiResponse}
              lexaiEvents={wf.lexaiEvents}
              loadLexAIEventsList={wf.loadLexAIEventsList}
              onEnableLexAi={wf.onEnableLexAi}
            />
          )}

          {wf.tab === "logs" && (
            <EventLogsTab
              logFilter={wf.logFilter}
              setLogFilter={wf.setLogFilter}
              logLimit={wf.logLimit}
              setLogLimit={wf.setLogLimit}
              logs={wf.logs}
              onLoadLogs={wf.onLoadLogs}
            />
          )}
        </div>
      </div>
    </div>
  );
}
